import { Component, OnInit } from '@angular/core';
import { Message, SelectItem,ConfirmationService} from 'primeng/primeng';
import { DriverService} from '../services/driver.service';
import { UserService} from '../services/user.service';

@Component({
  selector: 'app-driver',
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.css'],
  providers: [ConfirmationService]
})
export class DriverComponent implements OnInit {
  msgs: Message[] = [];
  driver: any;
  drivers : any [];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  status: SelectItem[];
  blockedDocument: boolean = false;
  statusFilter: SelectItem[];

  constructor(private driverService : DriverService,private userService : UserService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.statusFilter = [
            {label: 'Todos', value: null },
            {label: 'Habilitado', value: 'H'},
            {label: 'Inhabilitado', value: 'I'}
        ];
    this.init();

    this.status = [
            {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
            {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'}
        ];
  }
  init(){
    this.drivers = [];
    if(this.userService.userLoged.idCompany == null || this.userService.userLoged.idCompany == undefined){
      this.driverService.findAll().then(data => {
        let response: any = data;
        response.drivers.forEach(item => {
          this.drivers.push(item);
        });
      }).catch(err =>{
          this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      });
    }else{
      this.driverService.findByCompany(this.userService.userLoged.idCompany).then(data => {
        let response: any = data;
        response.drivers.forEach(item => {
          this.drivers.push(item);
        });
      }).catch(err =>{
          this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      });
    }
    this.driver = {status:"H",idCompany:this.userService.userLoged.idCompany};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  showAdd(){
    this.displayAdd = true;
  }

  showEdit(driver:any){
    this.driver=driver;
    this.displayEdit = true;
  }

  hide(){
    this.driver = {status:"H",idCompany:this.userService.userLoged.idCompany};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  add(){
    this.blockedDocument = true;
    this.driverService.create(this.driver).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  edit(){
    this.blockedDocument = true;
    this.driverService.edit(this.driver).then(data =>{
      let response: any = data;
      console.log(JSON.stringify(response));
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  del(id: number){
    this.confirmationService.confirm({
            message: 'Esta seguro de eliminar el registro seleccionado?',
            header: 'Confirmación',
            icon: 'fa fa-trash',
            accept: () => {
                this.blockedDocument = true;
                this.driverService.remove(id).then(data =>{
                  let response: any = data;
                    if(response.status == 'OK'){
                      this.init();
                      this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
                    }else{
                      this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
                    }
                    this.blockedDocument = false;
                }).catch(err =>{
                    this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
                    this.blockedDocument = false;
                });
            }
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/driver/driver.component.ts